import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { LoginComponent, LoginMenuComponent, LogoutComponent } from './components';
import { AuthRoutingModule } from './auth-routing.module';
import { AuthInterceptor } from './interceptors';

const components = [LoginComponent, LoginMenuComponent, LogoutComponent];

@NgModule({
  imports: [CommonModule, AuthRoutingModule],
  declarations: components,
  exports: components,
})
export class AuthModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: AuthModule,
      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthInterceptor,
          multi: true,
        },
      ],
    };
  }
}
